module.exports = __webpack_public_path__ + "img/cooking.17df1f0d.png";